import create from 'zustand';
export var useFirstRunVisibilityStore = create(function (set) { return ({
    isVisible: false,
    setIsVisible: function (isVisible) { return set(function (_) { return ({ isVisible: isVisible }); }); },
}); });
//# sourceMappingURL=store.js.map